import { render, staticRenderFns } from "./NewMedRouteDialog.vue?vue&type=template&id=4d6d7524&scoped=true&"
import script from "./NewMedRouteDialog.vue?vue&type=script&lang=js&"
export * from "./NewMedRouteDialog.vue?vue&type=script&lang=js&"
import style0 from "./NewMedRouteDialog.vue?vue&type=style&index=0&id=4d6d7524&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6d7524",
  null
  
)

export default component.exports